module.exports = __webpack_public_path__ + "images/shimo/form-list-43ca86978e0afdb4220b545e0b0e9d10.png";